<template>
  <div class="purchase-application" @click.stop>
    <div class="form">
      <h2 class="title page-title"><span>{{t('買取申込')}}</span></h2>
      <div class="form-group" :class="{'short':postData.payment_method !== 1}">
        <label>{{t('追跡番号')}}</label>
        <div class="form-one">
          <TextBox
            class="text-box tel"
            inputType="tel"
            v-model="postData.tracking_number"
          />
          <ErrorMessage
            v-if="errorMessage.tracking_number"
            class="error-message"
            :message="errorMessage.tracking_number[0]"
          />
        </div>
      </div>
      <div class="form-group" :class="{'short':postData.payment_method !== 1}">
        <label>{{ t('発送業者') }}</label>
        <div class="form-one">
          <select v-model="postData.shipping_method" class="text-box">
            <option value="">{{ t('選択してください') }}</option>
            <option value="ヤマト運輸">{{ t('ヤマト運輸') }}</option>
            <option value="日本郵便">{{ t('日本郵便') }}</option>
            <option value="佐川急便">{{ t('佐川急便') }}</option>
            <option value="西濃運輸">{{ t('西濃運輸') }}</option>
            <option value="FedEx">FedEx</option>
            <option value="DHL">DHL</option>
          </select>
          <ErrorMessage
            v-if="errorMessage.shipping_method"
            class="error-message"
            :message="errorMessage.shipping_method[0]"
          />
        </div>
      </div>
      <div class="form-group" :class="{'short':postData.payment_method !== 1}">
        <label>{{ t('発送枚数') }}</label>
        <div class="form-one">
          <TextBox
            class="text-box"
            inputType="tel"
            v-model="postData.card_number"
          />
          <ErrorMessage
            v-if="errorMessage.card_number"
            class="error-message"
            :message="errorMessage.card_number[0]"
          />
        </div>
      </div>
    </div>
    <div class="form">
      <h3 class="section-title">{{ t('査定額の受け取り方法') }}</h3>
      <div class="payment-method">
        <TabMenu class="tab-menu" :isPurchase="true" :tabs="paymentOptions" :activeTab="postData.payment_method" @update-activeTab="changeMethod" />
      </div>
      <div class="breakdown" :class="{'abroad': isAbroad}">
        <!-- <p class="left" v-if="!isAbroad">{{ t('※現金+査定額の5%分のコイン') }}</p>
        <p class="right" >{{ t('※査定額の120%分のコイン') }}</p> -->
        <span>{{ t('内訳') }}</span>
        <p v-if="postData.payment_method === 1 || postData.payment_method === 2" class="">{{ t('現金+ボーナスコイン1%') }}</p>
        <p v-if="postData.payment_method === 3" class="">{{ t('※査定額の110%分のコイン') }}</p>
      </div>
      <div class="bank-info" v-if="postData.payment_method == 1">
        <SubTitle class="subtitle">{{ t('口座情報') }}</SubTitle>
        <div class="form-group bank" :class="{'short':postData.payment_method !== 1}">
          <label>{{ t('銀行名') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="text"
            v-model="postData.bank_name"
            />
            <ErrorMessage
              v-if="errorMessage.bank_name"
              class="error-message"
              :message="errorMessage.bank_name[0]"
            />
          </div>
        </div>
        <div class="form-group bank" :class="{'short':postData.payment_method !== 1}">
          <label>{{ t('支店名') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="text"
              v-model="postData.branch_name"
            />
            <ErrorMessage
              v-if="errorMessage.branch_name"
              class="error-message"
              :message="errorMessage.branch_name[0]"
            />
          </div>
        </div>
        <div class="form-group bank" :class="{'short':postData.payment_method !== 1}">
          <label>{{ t('支店番号') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="number"
              v-model="postData.branch_number"
            />
            <ErrorMessage
              v-if="errorMessage.branch_number"
              class="error-message"
              :message="errorMessage.branch_number[0]"
            />
          </div>
        </div>
        <div class="form-group bank ">
          <label>{{ t('口座種別') }}</label>
          <select v-model="postData.account_type">
            <option value=1>{{ t('普通') }}</option>
            <option value=2>{{ t('当座') }}</option>
          </select>
        </div>
        <div class="form-group bank" :class="{'short':postData.payment_method !== 1}">
          <label>{{ t('口座番号') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="number"
              v-model="postData.account_number"
            />
            <ErrorMessage
              v-if="errorMessage.account_number"
              class="error-message"
              :message="errorMessage.account_number[0]"
            />
          </div>
        </div>
        <div class="form-group bank account-type">
          <label>{{ t('名義') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="text"
              v-model="postData.account_name"
          />
          <ErrorMessage
            v-if="errorMessage.account_name"
            class="error-message"
            :message="errorMessage.account_name[0]"
          />
          </div>
        </div>
      </div>
      <div class="paypal" v-if="postData.payment_method == 2">
        <div class="form-group" :class="{'short':postData.payment_method !== 1}">
          <label>{{ t('メールアドレス') }}</label>
          <div class="form-one">
            <TextBox
              class="text-box"
              inputType="text"
              v-model="postData.mailaddress"
            />
            <ErrorMessage
              v-if="errorMessage.mailaddress"
              class="error-message"
              :message="errorMessage.mailaddress[0]"
            />
          </div>
        </div>
      </div>
      <div class="id-section">
        <label class="upload-label">{{ t('身分証アップロード') }}</label>
        <div class="upload-container">
          <div class="upload-box-wrapper">
            <label for="front-upload" class="upload-box">{{ t('表面') }}+</label>
            <input type="file" accept="image/*" id="front-upload" @change="uploadFile('front', $event)" />
          </div>
          <div class="upload-box-wrapper">
            <label for="back-upload" class="upload-box back">
              <span>{{ t('裏面') }}+</span>
              <span class="upload-note">{{ t('マイナンバーカードの場合は表面のみ') }}</span>
            </label>
            <input type="file" accept="image/*" id="back-upload" @change="uploadFile('back', $event)" />
          </div>
        </div>
        <div v-if="idFrontPreview || idBackPreview" class="id-preview-container">
          <div v-if="idFrontPreview" class="id-preview">
            <p>{{ t('表') }}</p>
            <img :src="idFrontPreview" alt="身分証 表" class="id-image">
          </div>
          <div v-if="idBackPreview" class="id-preview">
            <p>{{ t('裏') }}</p>
            <img :src="idBackPreview" alt="身分証 裏" class="id-image">
          </div>
        </div>
        <ErrorMessage
          v-if="errorMessage.idFrontBase64"
          class="error-message"
          :message="t(errorMessage.idFrontBase64[0])"
        />
        <ErrorMessage
          v-if="errorMessage.idBackBase64"
          class="error-message"
          :message="t(errorMessage.idBackBase64[0])"
        />
      </div>
      <div class="form-group" :class="{'short':postData.payment_method !== 1}">
        <label>{{ t('備考') }}</label>
        <div class="form-one">
          <TextBox
            class="text-box"
            inputType="text"
            v-model="postData.memo"
            />
          <ErrorMessage
              v-if="errorMessage.memo"
              class="error-message"
              :message="errorMessage.memo[0]"
            />
        </div>
      </div>
    </div>
    <div class="form">
      <div class="form-group checkbox-group" :class="{'short':postData.payment_method !== 1}" >
        <input type="checkbox" id="agree" v-model="isAgreed" />
        <label for="agree">{{ t('買取フローを確認しました。その全てに同意します。') }}</label>
      </div>
      <div class="button-group">
        <button class="cancel-button" @click="$emit('handleCancel')">{{ t('キャンセル') }}</button>
        <BuyButton
          :class="{ disabled: !isAgreed }"
          class="purchase-btn"
          :text="t(' 申し込みへ ')"
          :isArrow="false"
          @handleSquareBtnClick="handleApplication"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BuyButton from '@/components/atoms/BuyButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import TabMenu from '@/components/molecules/TabMenu.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

import t from '@/plugins/i18n';

export default {
  name: 'PurchaseApplication',
  mixins: [t],

  components: {
    TextBox,
    TabMenu,
    BuyButton,
    SubTitle,
    ErrorMessage,
  },
  props: {
    errorMessage: {
      type: Object,
    },
    currentUser: {
      type: Object,
    },
  },
  data() {
    return {
      postData: {
        tracking_number: '',
        shipping_method: '',
        shipping_number: '',
        payment_method: 1,
        bank_name: '',
        branch_name: '',
        branch_number: '',
        account_type: 1,
        account_number: '',
        account_name: '',
        mailaddress: '',
        memo: '',
        idFrontBase64: '',
        idBackBase64: '',
      },
      idFrontPreview: null,
      idBackPreview: null,
      isAgreed: false,
    };
  },
  computed: {
    isAbroad() {
      return this.currentUser.country_id !== '84' && this.currentUser.country_id !== 84;
    },
    paymentOptions() {
      const options = [];
      // 「お振込み」は日本国内ユーザーのみに表示
      if (!this.isAbroad) {
        options.push({ id: 1, label: this.t('お振込み'), value: 'bank' });
      }
      options.push(
        { id: 2, label: 'PayPal', value: 'paypal' },
        { id: 3, label: this.t('コインで受け取り'), value: 'coin' },
      );
      return options;
    },
  },

  created() {
    // 国によって初期の支払い方法を設定
    if (this.isAbroad) {
      this.postData.payment_method = 2; // PayPal など
    }
  },

  methods: {
    uploadFile(type, event) {
      const file = event.target.files[0];
      if (!file) return;
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/heic', 'image/heif'];
      if (!allowedTypes.includes(file.type)) {
        alert(this.t('画像ファイルのみアップロードできます。'));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (type === 'front') {
          this.postData.idFrontBase64 = reader.result;
          this.idFrontPreview = reader.result;
        } else if (type === 'back') {
          this.postData.idBackBase64 = reader.result;
          this.idBackPreview = reader.result;
        }
      };
      reader.readAsDataURL(file);
    },
    changeMethod(id) {
      this.postData.payment_method = id;
    },
    handleApplication() {
      if (!this.isAgreed) return;
      if (this.postData.payment_method === 1) {
        this.postData.mailaddress = null;
      } else if (this.postData.payment_method === 2) {
        this.postData.bank_name = null;
        this.postData.branch_name = null;
        this.postData.branch_number = null;
        this.postData.account_type = null;
        this.postData.account_number = null;
        this.postData.account_name = null;
      } else if (this.postData.payment_method === 3) {
        this.postData.bank_name = null;
        this.postData.branch_name = null;
        this.postData.branch_number = null;
        this.postData.account_type = null;
        this.postData.account_number = null;
        this.postData.account_name = null;
        this.postData.mailaddress = null;
      }
      this.$emit('submitApplication', this.postData);
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-application {
  display: flex;
  text-align: center;
  width: auto;
  margin: auto;
  color: $gray;
  // min-height: 75vh;
  justify-content: space-evenly;
  flex-direction: column;
  .title {
    text-align: center;
    margin-bottom: 30px;
  }
  .page-title {
    span {
      padding: 5px 15px;
      border-radius: 10px;
      background-color: #d35400;
      color: white;
      box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
    }
  }
  .section-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin: 0px 0 8px;
    padding-left: 20px;
  }
  .form-one{
    display:flex;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    padding-right: 20px;
    align-items: flex-start
  }
  .error-message {
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 3px 0 10px 0;
  }
  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-left: 20px;
    label {
      font-size: 15px;
      font-weight: bold;
      width: 100px;
      min-width: 100px;
      text-align: left;
    }
    .text-box, input, select {
      width: 100%;
      padding: 8px;
      font-size: 15px;
      border: 1px solid #ccc;
      border-radius: 5px;
    }
    select {
      color: #2b90ff;
    }
    // &.short{
    //   margin-bottom: 20px;
    // }
    &.checkbox-group {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      font-size: 13px;
      label {
        font-size: 13px;
        width: auto;
        min-width: auto;
      }
      input {
        width: 16px;
        height: 16px;
        margin: 0 8px 0 0;
      }
    }
  }
  .bank-info {
    display: block;
    gap: 3px;
    margin: 0 auto;
    width: 100%;
    .subtitle {
      grid-column: span 2;
      font-size: 16px;
      margin: 5px 0;
      font-weight: bold;
      text-align: left;
      padding-left: 20px;
    }
    .form-group {
      display: flex;
      width: 100%;
      padding-left: 20px;
      label {
        width: 100px;
        min-width: 100px;
        font-weight: bold;
        text-align: left;
      }
      .text-box, input {
        width: 100%;
        padding: 8px;
        font-size: 14px;
        border: 1px solid #ccc;
        border-radius: 5px;
      }
      select {
        flex: 1;
        margin-right: 20px;
        line-height: 25px;
        font-size: 14px;
        padding: 5px 10px !important;
        @media screen and (max-width: $mobileWidth) {
          line-height: 16px;
        }
      }
    }
  }
  .account-holder {
    grid-column: span 2;
    display: flex;
    align-items: center;
  }
  .paypal {
    .form-group label {
      font-size: 12px;
    }
  }
  .payment-method {
    color: $gray2;
    display: flex;
    justify-content: center;
    padding: 0 20px;
    .tab-menu {
      width: 100%;
    }
  }
  .breakdown{
    font-size: 14px;
    margin: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: $tabletWidth) {
      font-size: 12px;
    }
    span {
      margin-right: 10px;
    }
    p {
      margin: 0;
      font-size: 16px;
      color: #db5707;
      font-weight: bold;
      @media screen and (max-width: $tabletWidth) {
        font-size: 14px;
        
      }
    }
  }
  .id-section {
    padding: 0 20px;
    margin-bottom: 15px;
    .upload-label {
      display: block;
      text-align: left;
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .upload-container {
      display: flex;
      gap: 10px;
      align-items: stretch;
    }
    .upload-box-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .upload-box {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #ccc;
      height: 80px;
      border-radius: 10px;
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
      width: 100%;
      box-sizing: border-box;
      @media screen and (max-width: $mobileWidth) {
        height: 100px;
        font-size: 16px;
      }
      &.back {
        position: relative;
      }
    }
    .upload-note {
      font-size: 10px;
      color: #888;
      font-weight: normal;
      position: absolute;
      bottom: 8px;
      left: 0;
      right: 0;
      text-align: center;
      @media screen and (max-width: $mobileWidth) {
        font-size: 8px;
      }
    }
    input[type="file"] {
      display: none;
    }
    .id-preview-container {
      display: flex;
      gap: 10px;
      margin-top: 10px;
      max-height: 150px;
      overflow-y: auto;
      padding: 5px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background: #f9f9f9;
      .id-preview {
        text-align: center;
        p {
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .id-image {
          width: 80px !important;
          height: auto;
          border-radius: 5px;
          border: 1px solid #ddd;
        }
      }
    }
  }
  .button-group {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    gap: 10px;
    padding-bottom: 10px;
    button {
      width: 45%;
      padding: 10px 60px;
      border: none;
      cursor: pointer;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      @media screen and (max-Width: $tabletWidth) {
        padding: 10px 35px;
      }
    }
    .purchase-btn{
      width: 50%;
      &.disabled {
      background: #ccc;
      color: #777;
      pointer-events: none;
      cursor: not-allowed;
    }
    }
    .cancel-button {
      width: 50%;
      color: #a1a2a2;
    }
  }
}
</style>
